import jsonToJsxComponent from '../jsonToJsxComponent';
import SponsoredGuidelinesJson from './SponsoredGuidelines.json';

const SponsoredGuidelines = jsonToJsxComponent(SponsoredGuidelinesJson);

// eslint-disable-next-line import/prefer-default-export
export { SponsoredGuidelines };
